import { FormatNumberOptions } from 'react-intl'

export const getFormatOptionPercent = (): FormatNumberOptions => {
  return {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    style: 'percent',
  }
}
